import React from "react";
import { Quote, Star } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "Rana Associates transformed how our Jaipur branches handle property valuations. Turnaround dropped from a week to 48 hours and every visit has photo evidence.",
    name: "Anand Sharma",
    role: "Deputy Manager · Retail Banking",
    org: "State Bank of India · Jaipur Circle",
    initials: "AS",
    accent: "bg-amber-100 text-amber-800",
  },
  {
    quote:
      "Pincode-based executive assignment and territory-managed audit gives us confidence for every high-value home loan we sanction.",
    name: "Meera Chauhan",
    role: "Credit Head",
    org: "HDFC Bank · Jodhpur Region",
    initials: "MC",
    accent: "bg-emerald-100 text-emerald-800",
  },
  {
    quote:
      "Pan-Rajasthan coverage on a single platform. Zero coordination overhead — we simply generate the lead and the report arrives.",
    name: "Rajesh Yadav",
    role: "Operations Director",
    org: "Bajaj Finance · Rajasthan West",
    initials: "RY",
    accent: "bg-rose-100 text-rose-800",
  },
];

export default function TestimonialsSection() {
  return (
    <section className="bg-slate-50 py-16 sm:py-24" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-amber-700">Trusted by Bankers</p>
          <h2 className="mt-2 font-heading text-2xl sm:text-4xl font-bold text-slate-950">
            What Rajasthan's lenders say about us
          </h2>
          <p className="mt-3 text-slate-600 max-w-2xl mx-auto text-sm sm:text-base">
            Verified feedback from banks and NBFCs actively running property valuations on Rana Associates.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t) => (
            <figure
              key={t.name}
              className="relative bg-white border border-slate-200 rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow"
              data-testid={`testimonial-${t.name.replace(/\s+/g, "-").toLowerCase()}`}
            >
              <Quote className="absolute -top-3 -left-3 h-8 w-8 text-amber-500 bg-white rounded-full p-1 border border-slate-200" />
              <div className="flex gap-0.5 mb-3">
                {["s1", "s2", "s3", "s4", "s5"].map((k) => (
                  <Star key={k} className="h-4 w-4 fill-amber-500 text-amber-500" />
                ))}
              </div>
              <blockquote className="text-slate-700 leading-relaxed text-sm sm:text-base">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 pt-4 border-t border-slate-100 flex items-center gap-3">
                <div className={`h-11 w-11 rounded-full flex items-center justify-center font-bold text-sm ${t.accent}`}>
                  {t.initials}
                </div>
                <div className="min-w-0">
                  <div className="font-semibold text-slate-950 text-sm">{t.name}</div>
                  <div className="text-xs text-slate-500 truncate">{t.role}</div>
                  <div className="text-[11px] text-amber-700 font-medium truncate mt-0.5">{t.org}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>

        {/* Trust badge strip */}
        <div className="mt-14 pt-10 border-t border-slate-200">
          <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-slate-500 text-center mb-6">
            Partner banks & NBFCs
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4 text-slate-400 font-heading font-bold text-lg sm:text-xl">
            <span>SBI</span>
            <span>HDFC</span>
            <span>ICICI</span>
            <span>Axis Bank</span>
            <span>Bajaj Finance</span>
            <span>Kotak</span>
            <span>Bank of Baroda</span>
            <span>Punjab National Bank</span>
          </div>
        </div>
      </div>
    </section>
  );
}
